import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  name: string;
  email: string;
  phone_number: string;
  company_name: string;
  subject: string;
  message: string;
  loading: boolean;
  subjectList = ["解決方案詢問", "顧問服務需求", "人力服務需求", "維護/續約相關", "合作洽詢", "其他"];

  constructor(private http: HttpClient, public datepipe: DatePipe) { }

  ngOnInit() {

  }

  sendemail() {
    this.subject = $('.nice-select .current').text();
    let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (this.name == null) {
      alert("請輸入姓名");
    } else if (this.email == null) {
      alert("請輸入email");
    } else if (regexp.test(this.email) == false) {
      alert("請輸入正確email");
    } else if (this.phone_number == null) {
      alert("請輸入電話號碼");
    } else if (this.company_name == null) {
      alert("請輸入公司名稱");
    } else if (this.subject == 'Subject 內容主旨') {
      alert("請選擇主旨");
    } else if (this.message == null) {
      alert("請輸入內容");
    } else {
      this.loading = true;
      interface MailObj {
        mail_name: string;
        mail_email: string;
        mail_phone_number: string;
        mail_company_name: string;
        mail_subject: string;
        mail_message: string;
      }

      // let newMessage = this.message.replace(/\r?\n/g, '<br />');

      // let obj: MailObj = JSON.parse('{ "mail_name": "' + this.name + '", "mail_email": "' + this.email + '", "mail_phone_number": "' + this.phone_number + '", "mail_company_name": "' + this.company_name + '", "mail_subject": "' + this.subject + '", "mail_message": "' + newMessage + '" }')

      // this.http.post('http://192.168.0.148:5000/sendmail', obj, {
      //   headers: new HttpHeaders({
      //     'Content-Type': 'application/json; charset=UTF-8',
      //   }), responseType: 'text', observe: 'response'
      // })
      //   .subscribe(
      //     val => {
      //       this.loading = false;
      //       alert(val.body);
      //       window.location.reload();
      //     },
      //     error => {
      //       console.log('Post call in error', error);
      //     }
      //   );
      
      let now = new Date();
      let nowtime = this.datepipe.transform(now, 'yyyy/MM/dd HH:mm:ss');

      this.http.get('https://script.google.com/macros/s/AKfycbxJn9xBTauafwqDfcEjLrmAhAWMsbBZL5WQoS2nYRnf3FQM1PCNkxHEBGpNbIJ2K8g8eg/exec', {
          params: {
              time: nowtime,
              name: this.name,
              mail: this.email,
              phone: this.phone_number,
              company: this.company_name,
              subject: this.subject,
              message: this.message
          },
          observe: 'response',
          responseType: 'text',
      }).subscribe(data => {
          this.loading = false;
          if (data.status == 200) {
              if (data.body == "成功") {
                  alert("已收到您的來信，我們將會盡快回復您，謝謝！")
              } else {
                  alert("伺服器錯誤，請稍後再嘗試，謝謝！")
              }
          } else {
              alert("伺服器錯誤，請稍後再嘗試，謝謝！")
          }
          window.location.reload();
      });
    }

  }

}
